import LogoGradientIcon from '../../icons/LogoGradientIcon'
import { SegmentedControl, Tooltip } from '@radix-ui/themes'
import { useDispatch, useSelector } from 'react-redux'
import { selectStats, setTabToShow } from '../../reducers/stats'
import { IconInfoCircle } from '@tabler/icons-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { selectUser, setSession } from '../../reducers/users'
import { SessionState } from '../../types/UserTypes'
import { inPov } from '../../utils/session'

const DashboardHeader = () => {
  const navigate = useNavigate()
  const { session, currentPage } = useSelector(selectUser)
  const dispatch = useDispatch()
  const { tabToShow, dashboardLastUpdated } = useSelector(selectStats)

  useEffect(() => {
    const goToConfigured = localStorage.getItem('SSO_CONFIGURED_COOKIE')

    if (goToConfigured === 'true') {
      navigate('/settings')
    }
    if (window.location.search.includes('error=sso-unauthorized')) {
      navigate('/sso-error')
    }
  }, [])

  useEffect(() => {
    const storedSession = localStorage.getItem('session') as string

    if (currentPage === 'SSO_ERROR') {
      localStorage.setItem('session', '{}')
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
      dispatch(setSession(undefined))
    } else if (!session && storedSession === '{}' && currentPage !== 'SSO_ERROR') {
      localStorage.setItem('session', '{}')
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
      dispatch(setSession(undefined))
      navigate('/login')
    } else if (!session && storedSession !== '{}') {
      dispatch(setSession(JSON.parse(storedSession) as SessionState))
    }
  }, [session])

  useEffect(() => {
    if (import.meta.env.VITE_PRETTY_ENV !== 'Production' && import.meta.env.VITE_ON_PREM === 'false') {
      document.title = '[' + import.meta.env.VITE_PRETTY_ENV + '] ' + 'iVerify EDR Portal'
    }
  }, [])

  const getHoursAgo = (date?: string) => {
    if (!date) {
      return ''
    }
    const now = new Date()
    const diff = now.getTime() - new Date(date).getTime()
    const hours = Math.floor(diff / (1000 * 60 * 60))
    if (hours === 1) {
      return `${hours} hour ago`
    }
    return `${hours} hours ago`
  }

  return (
    <div className="w-full absolute h-[74px] flex" style={{ top: inPov(session) ? '42px' : '0px' }}>
      <div className="h-[26px] flex items-center mt-6 ml-6 w-[182px]">
        <LogoGradientIcon height="26" width="71" />
      </div>
      <div className="grid grid-cols-3 w-full mx-10">
        <div className="font-semibold text-black text-xl dark:text-white my-auto">Dashboard</div>
        <div className="m-auto">
          <SegmentedControl.Root
            value={tabToShow}
            defaultValue="risk"
            className="h-[38px] mx-auto bg-controllerBackground text-controllerText"
            onValueChange={(tab: string) => dispatch(setTabToShow(tab))}
          >
            <SegmentedControl.Item value="risk">
              <div className="flex">Risk</div>
            </SegmentedControl.Item>
            <SegmentedControl.Item value="rollout">
              <div className="flex">Rollout</div>
            </SegmentedControl.Item>
          </SegmentedControl.Root>
        </div>
        {dashboardLastUpdated && (
          <div className="text-xs text-gray-500 dark:text-gray-300 text-right my-auto pl-20 ml-auto flex gap-1">
            Last updated {getHoursAgo(dashboardLastUpdated)}
            <Tooltip content="Data refreshes every 12 hours" side="top" align="end" className="max-w-[240px]">
              <IconInfoCircle className="cursor-pointer flex-shrink-0" size="16" />
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  )
}

export default DashboardHeader
